var $ = require('jquery');
// number count start
  var counted = 0;
  $(window).scroll(function() {
    if($('#counter').length > 0)
    {    
    // var oTop = window.innerHeight-$('#counter').offset().top;
    // console.log($(window).scrollTop());
    // console.log(oTop);
      if (counted == 0 && $(window).scrollTop() > 0) {
          $('.count').each(function() {
              var $this = $(this),
                  countTo = $this.attr('data-count');
              $({
                //   countNum: $this.text()
                countNum: 0
              }).animate({
                      countNum: countTo
                  },
                  {
                      duration: 2000,
                      easing: 'swing',
                      step: function() {
                          $this.text(Math.floor(this.countNum));
                      },
                      complete: function() {
                        if(window.location.href.indexOf("/id/sus")>-1 && countTo.indexOf(".")==-1)
                        {
                            var alttext=separateWithComma(countTo);
                            $this.text(alttext);
                            function separateWithComma(number) {
                                var separatedNumber = "";
                                //var numberString = number.toString();
                                separatedNumber = number.slice(0,number.length-1)+","+number.slice(2)
                                return separatedNumber;
                            }
                        }
                        else{
                            $this.text(this.countNum.toLocaleString());
                        }
                      }

                  });
          });
          counted = 1;
      }
    }
  });
  // number count end